import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-body-2 text-medium-emphasis mb-0 automation-card__job" }
const _hoisted_2 = { class: "d-flex align-center ga-2 text-caption text-medium-emphasis" }
const _hoisted_3 = { class: "text-primary" }
const _hoisted_4 = { class: "text-disabled text-uppercase" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    color: "background",
    variant: "elevated",
    elevation: "4",
    class: "automation-card fill-height d-flex flex-column",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open', _ctx.automation.id)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_item, { class: "pb-2" }, {
        prepend: _withCtx(() => [
          _createVNode(_component_v_avatar, {
            color: "primary",
            variant: "tonal",
            rounded: "lg",
            size: "44"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: _ctx.meta.icon
              }, null, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        append: _withCtx(() => [
          _createVNode(_component_v_chip, {
            size: "x-small",
            variant: "tonal",
            color: _ctx.automation.status === 'active' ? 'success' : 'grey'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.automation.status === 'active' ? 'Active' : 'Paused'), 1)
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-truncate" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.automation.name), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "pt-0 flex-grow-1" }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.automation.job), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_card_text, { class: "py-3" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_icon, {
              icon: "mdi-clock-outline",
              size: "small",
              color: "primary"
            }),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.whenLabel), 1),
            _createVNode(_component_v_spacer),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.meta.label), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}